import { DateTime } from "luxon";
import { Table } from "react-bootstrap";
import { useProjectedGraphDataContext } from "../contexts/amazonPageSpeedViewsProjectedDataContext";

const AmazonViewProjectedSummary = () => { 

  const todaysDate = DateTime.local().toUTC()
  const startOfThisWeek = todaysDate.startOf('week').minus({days: 1})
  const endOfThisWeek = startOfThisWeek.plus({days: 6})

  const {projectedSummary} = useProjectedGraphDataContext()


  return (
    <div className="p-4 shadow-sm bg-white rounded">
      <h4 className="mb-0 fw-semibold">Projected Summary ({startOfThisWeek.toFormat("MM/dd/yyyy")} - {endOfThisWeek.toFormat("MM/dd/yyyy")})</h4>
      <Table bordered hover size="sm" responsive="md">
        <thead className="table-light">
          <tr>
            <th>Type</th>
            <th>Percentage</th>
            <th>Views</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1 Day</td>
            <td>{projectedSummary.oneDayPercent.toFixed(2)}%</td>
            <td>{projectedSummary.oneDayViews}</td>
          </tr>
          <tr>
            <td>2 Day</td>
            <td>{projectedSummary.twoDayPercent.toFixed(2)}%</td>
            <td>{projectedSummary.twoDayViews}</td>
          </tr>
          <tr>
            <td>More Than 2 Days</td>
            <td>{projectedSummary.greaterThanTwoDayPercent.toFixed(2)}%</td>
            <td>{projectedSummary.greaterThanTwoDayViews}</td>
          </tr>
          <tr className="fw-bold">
            <td>Total</td>
            <td></td>
            <td>{projectedSummary.totalViews}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default AmazonViewProjectedSummary;